'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dEnum$002dSample$0024package$0024$002dBasket$00241 from "./samples.-Enum-Sample$package$-Basket$1.js";
var $p;
/** @constructor */
function $c_Lsamples_EnumSample$package$Basket$3$() {
}
export { $c_Lsamples_EnumSample$package$Basket$3$ as $c_Lsamples_EnumSample$package$Basket$3$ };
$p = $c_Lsamples_EnumSample$package$Basket$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EnumSample$package$Basket$3$;
/** @constructor */
function $h_Lsamples_EnumSample$package$Basket$3$() {
}
export { $h_Lsamples_EnumSample$package$Basket$3$ as $h_Lsamples_EnumSample$package$Basket$3$ };
$h_Lsamples_EnumSample$package$Basket$3$.prototype = $p;
$p.b = (function() {
  return "Basket";
});
$p.Us = (function(x$0) {
  return new $j_samples$002e$002dEnum$002dSample$0024package$0024$002dBasket$00241.$c_Lsamples_EnumSample$package$Basket$1(x$0.g(0), x$0.g(1));
});
$p.y = (function(p) {
  return this.Us(p);
});
var $d_Lsamples_EnumSample$package$Basket$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EnumSample$package$Basket$3$, "samples.EnumSample$package$Basket$3$", ({
  p6: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_EnumSample$package$Basket$3$ as $d_Lsamples_EnumSample$package$Basket$3$ };
